export default theme => ({
  offersContainer: {
    margin: '64px 0'
  },
  info: {
    display: 'flex',
    alignItems: 'baseline'
  },
  icon: {
    color: theme.secondary[0],
    marginRight: 4,
    fontSize: 14
  }
})
